import React from 'react'
import { Button } from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';


const BackButtonLogin = (props) => {

    const BootstrapButton = withStyles({
        root: {
          boxShadow: 'none',
          textTransform: 'none',
          fontSize: 15,
          padding: '6px 12px',
          lineHeight: 1.5,
          backgroundColor: 'none',
          borderColor: 'none',
          color: '#9EA0A5',
          fontWeight: "normal",
          fontFamily: [
            'Roboto',
          ].join(','),
          '&:focus': {
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
          },
        },
      })(Button);

    return (
        <BootstrapButton className="mt10" onClick={()=> props.to ? props.history.push(props.to) : props.history.push('/')}>
            <ArrowBackIcon /> Volver
        </BootstrapButton>
    )
}

export default withRouter(BackButtonLogin);